import { LngLat } from 'mapbox-gl';
import { observer } from 'mobx-react-lite';
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import useProperty from '../../hooks/useProperty';
import PropertySummary from './PropertySummary';

function PropertyDetailsSummaryTab() {
    const { longitude, latitude } = useParams();
    const coordinates = useMemo(() => new LngLat(Number(longitude), Number(latitude)), [longitude, latitude]);
    const property = useProperty(coordinates).property!;

    return <PropertySummary property={property} />;
}

export default observer(PropertyDetailsSummaryTab);